import Vue from 'vue';
import { EC_ENV_PROD } from './params';
import Sidebar from './components/sidebar/Sidebar';
import store from './store/sidebar';
import { BootstrapVue } from 'bootstrap-vue';
import {SET_ACCOUNT_NAME, SET_PATH, SET_PROJECT_ID} from "@/store/sidebar/mutations";
import {getData, updateDataBeforeMount} from "@/utils/before-mount";
import RippleDirective from "@/directives/Ripple";
import VueNoty from "vuejs-noty";
import {initApi} from "@/api-ts/api";
import {WidgetContentItemsApi} from "@/api-ts/widget-content-items";
import OutsideClick from "@/directives/OutsideClick";

Vue.use(VueNoty);
Vue.use(BootstrapVue);
Vue.directive('ripple', RippleDirective);
Vue.directive('outside-click', OutsideClick);

let sidebarVm;
const sidebarElement = document.getElementById('sidebar-vue');

if (sidebarElement) {
	sidebarVm = new Vue({
		el: '#sidebar-vue',
		store,
		components: {
			Sidebar
		},
		beforeMount() {

			updateDataBeforeMount();

			let {projectId, lastSelectedProjectId, path, accountName} = getData();
			projectId = !projectId && lastSelectedProjectId ? lastSelectedProjectId : projectId;

			this.$store.commit(SET_PROJECT_ID, projectId);
			this.$store.commit(SET_PATH, path);
			this.$store.commit(SET_ACCOUNT_NAME, accountName);

			const userApiKey = this?.$el?.dataset?.userApiKey ? this.$el.dataset.userApiKey : '';
			initApi(userApiKey, WidgetContentItemsApi);
		},
		template: '<Sidebar/>',
	});

	Vue.config.devtools = EC_ENV !== EC_ENV_PROD;
}

export default sidebarVm;
